/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CampaignNumberDataSource } from './CampaignNumberDataSource';
import {
    CampaignNumberDataSourceFromJSON,
    CampaignNumberDataSourceFromJSONTyped,
    CampaignNumberDataSourceToJSON,
    CampaignNumberDataSourceToJSONTyped,
} from './CampaignNumberDataSource';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface CampaignNumberGraphData
 */
export interface CampaignNumberGraphData {
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignNumberGraphData
     */
    labels?: Array<string>;
    /**
     * 
     * @type {Array<CampaignNumberDataSource>}
     * @memberof CampaignNumberGraphData
     */
    dataSources?: Array<CampaignNumberDataSource>;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof CampaignNumberGraphData
     */
    snapshot?: PrecalculationSnapshotReadMetadata | null;
}

/**
 * Check if a given object implements the CampaignNumberGraphData interface.
 */
export function instanceOfCampaignNumberGraphData(value: object): value is CampaignNumberGraphData {
    return true;
}

export function CampaignNumberGraphDataFromJSON(json: any): CampaignNumberGraphData {
    return CampaignNumberGraphDataFromJSONTyped(json, false);
}

export function CampaignNumberGraphDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampaignNumberGraphData {
    if (json == null) {
        return json;
    }
    return {
        
        'labels': json['labels'] == null ? undefined : json['labels'],
        'dataSources': json['dataSources'] == null ? undefined : ((json['dataSources'] as Array<any>).map(CampaignNumberDataSourceFromJSON)),
        'snapshot': json['snapshot'] === undefined ? undefined : json['snapshot'] === null ? null : PrecalculationSnapshotReadMetadataFromJSON(json['snapshot']),
    };
}

export function CampaignNumberGraphDataToJSON(json: any): CampaignNumberGraphData {
    return CampaignNumberGraphDataToJSONTyped(json, false);
}

export function CampaignNumberGraphDataToJSONTyped(value?: CampaignNumberGraphData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'labels': value['labels'],
        'dataSources': value['dataSources'] == null ? undefined : ((value['dataSources'] as Array<any>).map(CampaignNumberDataSourceToJSON)),
        'snapshot': PrecalculationSnapshotReadMetadataToJSON(value['snapshot']),
    };
}

